import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2642e67c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "account-pop-log" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Table = _resolveComponent("Table")!
  const _component_ConfigProvider = _resolveComponent("ConfigProvider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ConfigProvider, { locale: _ctx.zhCN }, {
      default: _withCtx(() => [
        _createVNode(_component_Table, {
          columns: _ctx.columns,
          "data-source": _ctx.tableData,
          rowKey: (record) => record.id,
          scroll: {
              y: '2.7rem',
            },
          pagination: false,
          bordered: ""
        }, null, 8, ["columns", "data-source", "rowKey", "scroll"])
      ]),
      _: 1
    }, 8, ["locale"])
  ]))
}